import type { VehicleStrategy } from './VehicleStrategy'
import { MotorcycleStrategy } from './MotorcycleStrategy'
import { CarStrategy } from './CarStrategy'
import { GoKartStrategy } from './GoKartStrategy'

export type VehicleType = 'motorcycle' | 'car' | 'go-kart'

export const DEFAULT_VEHICLE_TYPE: VehicleType = 'motorcycle'

export function createVehicleStrategy(
  vehicleType: VehicleType = DEFAULT_VEHICLE_TYPE
): VehicleStrategy {
  switch (vehicleType) {
    case 'motorcycle':
      return new MotorcycleStrategy()
    case 'car':
      return new CarStrategy()
    case 'go-kart':
      return new GoKartStrategy()
    default: {
      const exhaustiveCheck: never = vehicleType
      throw new Error(`Unsupported vehicle type: ${exhaustiveCheck as string}`)
    }
  }
}

export function getSupportedVehicleTypes(): readonly VehicleType[] {
  return ['motorcycle', 'car', 'go-kart'] as const
}

export function isValidVehicleType(value: string): value is VehicleType {
  return value === 'motorcycle' || value === 'car' || value === 'go-kart'
}
